import InSicht from 'insicht';
import formatNumber from '@/utils/formatnumber';
import { fwgpricecent } from '@/helpers/FilterFwg';

export default function(dom, opts, htmlcomponent) {
	let options = {
		speed: 100,
		format: {
			decimals: 0,
			thousand: '\'',
		},
		...opts
	};

	const formatStatNumber = (number, target, unit) => {
		let decimals = Math.min(target.toString().split('.')[1]?.length || 0, 2);
		number = formatNumber(number, { ...options.format, decimals });

		if (['CHF', '$', '€'].includes(unit)) {
			number = `${unit} ${number}`;

			if (!decimals) {
				number = `${number}.–`;
			}
		}
		else if (unit) {
			number = `${number}${unit}`;
		}

		return number;
	}

	let stats = new InSicht({
    container: dom,
    selector: '[data-target]',
    visibleClass: 'stats-counter__col-value--count',
    stagger: 100,
		threshold: 0,
		// autoReset: true, // only for dev ;)
    init: (counter) => {
			const placeholder = counter.querySelector('[data-placeholder]');
			const display = counter.querySelector('[data-display]');
			const originalTarget = counter.dataset.target;
			const target = +originalTarget;
			const unit = counter.dataset.unit;

			placeholder.innerText = formatStatNumber(target, originalTarget, unit);
			display.innerText = 0;
		},
    done: (counter) => {
			const originalTarget = counter.dataset.target;
			const target = +originalTarget;
			const display = counter.querySelector('[data-display]');
			const unit = counter.dataset.unit;

			const updateCount = () => {
				const count = +counter.dataset.value;
				const inc = target / options.speed;

				if (count < target) {
					const newValue = count + inc;
					counter.dataset.value = newValue;
					display.innerText = formatStatNumber(Math.min(newValue, target), originalTarget, unit);
					frame = requestAnimationFrame(updateCount);
				}
				else {
					cancelAnimationFrame(frame);
					display.innerText = formatStatNumber(target, originalTarget, unit);
				}
			};
			let frame;

			counter.dataset.value = 0;

			updateCount();
		},
	});


  htmlcomponent?.onElementDestroy?.(dom, () => {
    try {
      stats.destroy();
      stats = null;
    }
    catch(err) {
      // nothing to do
    }
  });

}
